import React, { useState, memo, useEffect } from "react";
import { Container, IconButton } from "@mui/material";

import search from "../../../assets/images/search.png";
import message from "../../../assets/images/message.png";

import {
  ChatSearchMain,
  ChatSearchWrap,
  SearchInputMain,
  ChatBtn,
  SearchButton,
} from "./styles/SearchStyles";
import UsersPopup from "./UsersPopup";
import { SearchClean } from "../shared/styles/SearchStyle";

const ChatSearch = ({
  AllData = "",
  setAllData = () => {},
  ActiveType = "",
}) => {
  const [remaingData, setremaingData] = useState(false);
  useEffect(() => {
    setremaingData(AllData);
  }, []);

  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState("");

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleButtonClick = () => {
    const FilteredData = AllData.data.filter((value) => {
      if (value.sender_name) {
        return value.sender_name
          .toLowerCase()
          .includes(searchText.toLowerCase());
      }
      return false;
    });

    setAllData({ data: FilteredData });
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const CleanSearch = () => {
    setAllData(remaingData);
    setSearchText("");
  };

  return (
    <>
      <Container maxWidth="lg">
        <ChatSearchMain>
          <ChatSearchWrap>
            <SearchInputMain>
              <img src={search} alt="search" />
              <input
                type="text"
                value={searchText}
                onChange={handleInputChange}
                placeholder="Search User..."
              />

              {/* clean button */}
              {searchText && (
                <>
                  <IconButton onClick={handleButtonClick}>
                    <SearchButton />
                  </IconButton>
                  <IconButton onClick={CleanSearch}>
                    <SearchClean />
                  </IconButton>
                </>
              )}
            </SearchInputMain>
            <ChatBtn>
              <IconButton onClick={handleOpenDialog}>
                <img src={message} alt="message" />
              </IconButton>
            </ChatBtn>
          </ChatSearchWrap>
        </ChatSearchMain>
      </Container>
      <UsersPopup
        open={openDialog}
        handleClose={handleCloseDialog}
        UserType={ActiveType}
      />
    </>
  );
};

export default memo(ChatSearch);
